/* ---------------------------------------------------------------------
 *                           Import Packages
 * --------------------------------------------------------------------- */

// React
import React from "react";

// MUI
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  Box,
} from "@mui/material";

/* ---------------------------------------------------------------------
 *                        LogoutDialog Component
 * --------------------------------------------------------------------- */
/**
 * 定义退出登录框组件
 * @static
 * @function LogoutDialog
 * @returns {component} LogoutDialog
 */
export default function LogoutDialog({
  openLogoutDialog,
  onCloseLogoutDialog,
  onConfirmLogout,
}) {
  /* ---------------------------------------------------------------------
   *                            Render Component
   * --------------------------------------------------------------------- */

  return (
    <Dialog
      open={openLogoutDialog}
      onClose={onCloseLogoutDialog}
      disableEscapeKeyDown={false}
      aria-describedby="alert-back-logout-dialog"
      PaperProps={{
        sx: {
          width: 360,
          height: 180,
          borderRadius: 3,
          boxShadow: 8,
          p: 0,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: 3,
          px: 3,
        }}
      >
        <DialogTitle
          id="alert-back-logout-dialog-title"
          align="center"
          sx={{
            fontSize: 25,
            fontWeight: 600,
            p: 0,
            mb: 1,
            color: "text.primary",
          }}
        >
          确认要退出吗?
        </DialogTitle>
      </Box>
      <DialogActions
        sx={{
          display: "flex",
          flexFlow: "row nowrap",
          justifyContent: "center",
          gap: 2,
          py: 2,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={onConfirmLogout}
          autoFocus
          sx={{ minWidth: 90, borderRadius: 2, fontWeight: 500 }}
        >
          确认
        </Button>
        <Button
          variant="outlined"
          color="inherit"
          onClick={onCloseLogoutDialog}
          sx={{ minWidth: 90, borderRadius: 2, fontWeight: 500 }}
        >
          取消
        </Button>
      </DialogActions>
    </Dialog>
  );
}
